import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_putaway_list_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    processing_queue_guid :fromDatatype.GuidDataFieldInterface;
    warehouse_guid :fromDatatype.GuidDataFieldInterface;
    warehouse_code :fromDatatype.VarcharDatatypeInterface;
    running_no :fromDatatype.VarcharDatatypeInterface;
    layout_hdr_guid :fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid :fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_scan_code :fromDatatype.VarcharDatatypeInterface;
    layout_node_type_guid :fromDatatype.GuidDataFieldInterface;
    space_allocation_desc :fromDatatype.VarcharDatatypeInterface;
    container_hdr_guid :fromDatatype.GuidDataFieldInterface;
    container_code :fromDatatype.VarcharDatatypeInterface;
    container_scan_code :fromDatatype.VarcharDatatypeInterface;
    container_item_code_guid :fromDatatype.GuidDataFieldInterface;
    process_status :fromDatatype.VarcharDatatypeInterface;
    description :fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_wms_putaway_list_RowClass implements bl_wms_putaway_list_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    processing_queue_guid :fromDatatype.GuidDataFieldInterface;
    warehouse_guid :fromDatatype.GuidDataFieldInterface;
    warehouse_code :fromDatatype.VarcharDatatypeInterface;
    running_no :fromDatatype.VarcharDatatypeInterface;
    layout_hdr_guid :fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_guid :fromDatatype.GuidDataFieldInterface;
    layout_node_hdr_scan_code :fromDatatype.VarcharDatatypeInterface;
    layout_node_type_guid :fromDatatype.GuidDataFieldInterface;
    space_allocation_desc :fromDatatype.VarcharDatatypeInterface;
    container_hdr_guid :fromDatatype.GuidDataFieldInterface;
    container_code :fromDatatype.VarcharDatatypeInterface;
    container_scan_code :fromDatatype.VarcharDatatypeInterface;
    container_item_code_guid :fromDatatype.GuidDataFieldInterface;
    process_status :fromDatatype.VarcharDatatypeInterface;
    description :fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}